// src/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken,  setAuthToken]  = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [adminUser,  setAdminUser]  = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('bgn_admin_token');
    if (token) {
      setAuthToken(token);
      setIsLoggedIn(true);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('bgn_admin_token');
    setAuthToken(null);
    setIsLoggedIn(false);
    setAdminUser(null);
  };

  return (
    <AuthContext.Provider value={{ authToken, setAuthToken, isLoggedIn, setIsLoggedIn, adminUser, setAdminUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};